import React from "react";
import "./KVKK.css";

const KVKK = () => {
  return (
    <div className="kvkk-page">
      <section className="kvkk-hero">
        <h1>Kişisel Verilerin Korunması <span>Aydınlatma Metni</span></h1>
        <p className="kvkk-hero-url">www.lingify.co</p>
      </section>

      <div className="kvkk-content">
        <div className="kvkk-container">

          <h2>Veri Sorumlusu</h2>
          <table className="kvkk-info-table">
            <tbody>
              <tr><td>Veri Sorumlusu</td><td>Lingify Sağlık Teknolojileri A.Ş.</td></tr>
              <tr><td>Adres</td><td>Reşitpaşa Mah. Katar Cad. İTÜ ARI Teknokent 3 Binası No: 4/B204 Sarıyer/İstanbul</td></tr>
              <tr><td>MERSİS</td><td>0608171176500001</td></tr>
              <tr><td>E-posta</td><td>info@lingify.co</td></tr>
            </tbody>
          </table>

          <h2>Bu Metin Kimi Kapsıyor?</h2>
          <p>www.lingify.co sitesindeki talep formunu dolduran ve/veya e-posta bültenine abone olan kişileri kapsar.</p>

          <h2>Hangi Verinizi, Neden, Hangi Hukuki Nedenle İşliyoruz?</h2>
          <p>Verileriniz elektronik ortamda site formları ile toplanır. Tüm işlemler kanundaki diğer hukuki sebeplere dayanmaktadır.</p>

          <table className="kvkk-data-table">
            <thead>
              <tr>
                <th>Toplanan Veri</th>
                <th>Amaç</th>
                <th>Hukuki Dayanak</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ad-soyad, e-posta, telefon</td>
                <td>Talep formunun alınması ve yanıtlanması</td>
                <td>Sözleşmenin kurulması (m.5/2-c)</td>
              </tr>
              <tr>
                <td>Meslek/profil bilgisi (danışan, doktor, bakım veren, terapist)</td>
                <td>Doğru hizmet yönlendirmesi</td>
                <td>Sözleşmenin ifası (m.5/2-c)</td>
              </tr>
              <tr>
                <td>E-posta adresi (bülten aboneliği)</td>
                <td>Bülten ve duyuru gönderimi</td>
                <td>6563 s. Kanun kapsamında ETK onayı</td>
              </tr>
              <tr>
                <td>IP, cihaz/tarayıcı bilgisi</td>
                <td>Site güvenliği ve teknik altyapı</td>
                <td>Meşru menfaat (m.5/2-f)</td>
              </tr>
              <tr>
                <td>Onay kayıtları (checkbox, zaman damgası)</td>
                <td>Hukuki yükümlülük ispatı</td>
                <td>Hukuki yükümlülük (m.5/2-ç)</td>
              </tr>
            </tbody>
          </table>

          <h2>Verilerinizi Kimlerle Paylaşıyoruz?</h2>
          <p>Kişisel verileriniz, yalnızca aşağıdaki taraflarla ve yukarıdaki amaçlarla sınırlı olarak paylaşılabilir:</p>
          <ul>
            <li>Hosting/sunucu ve e-posta altyapı sağlayıcıları</li>
            <li>Yasal zorunluluk halinde yetkili kamu kurum ve kuruluşları</li>
            <li>Altyapı sağlayıcılarına bağlı olarak verileriniz yurt dışındaki sunucularda işlenebilir</li>
          </ul>

          <h2>Verilerinizi Ne Kadar Süre Saklıyoruz?</h2>
          <table className="kvkk-data-table">
            <thead>
              <tr>
                <th>Veri</th>
                <th>Saklama Süresi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>İletişim/talep kayıtları</td>
                <td>Talebin sonuçlandırılmasından itibaren 2 yıl</td>
              </tr>
              <tr>
                <td>Bülten aboneliği</td>
                <td>Abonelik iptal edilene kadar</td>
              </tr>
              <tr>
                <td>Teknik loglar</td>
                <td>6 ay</td>
              </tr>
              <tr>
                <td>Onay kayıtları</td>
                <td>Zamanaşımı süresi boyunca</td>
              </tr>
            </tbody>
          </table>
          <p>Süresi dolan veriler silinir, yok edilir veya anonim hale getirilir.</p>

          <h2>Haklarınız</h2>
          <p>KVKK m.11'de sayılan tüm haklara (bilgi edinme, düzeltme, silme, itiraz vb.) sahipsiniz. Başvurularınızı sistemde bulunan e-posta adresiniz aracılığı ile <strong>info@lingify.co</strong> adresine iletebilirsiniz. Başvurular 30 gün içinde sonuçlandırılır.</p>
        </div>
      </div>
    </div>
  );
};

export default KVKK;
